import "./work.css";
import React from "react";
import Slide from "react-reveal/Slide";
import { BoltLoader } from "react-awesome-loaders";

class Moreworks extends React.Component {
  const;
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    let x = document.getElementById("click").value;
    return x;
  }

  // ComponentDidMount is used to
  // execute the code
  componentDidMount() {
    fetch("https://api.github.com/users/krishnanand654/repos?per_page=")
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          items: json,
          DataisLoaded: true,
        });
      });
  }

  render() {
    const { DataisLoaded, items } = this.state;

    if (!DataisLoaded)
      return (
        <div>
          <Slide left>
            <h1 className="work-title">Works</h1>
          </Slide>
          <div className="bolt">
            <BoltLoader
              className={"loaderbolt"}
              boltColor={"#6366F1"}
              backgroundBlurColor={"#E0E7FF"}
            />
          </div>
        </div>
      );

    return (
      <div>
        <Slide bottom>
          <h1 className="work-title" style={{ marginTop: "50px" }}>
            Works
          </h1>
        </Slide>

        <div className="works-ctn">
          <div
            className="card-ctn"
            style={{ animation: "scroll 40s linear infinite" }}
          >
            {items.map((item) => (
              <Slide bottom>
                <div id="card" className="card">
                  <h1
                    style={{
                      fontWeight: "400",
                      fontSize: "48px",
                      margin: "0 0 50px",
                    }}
                  >
                    {items.indexOf(item).toString().length > "1"
                      ? items.indexOf(item)
                      : "0" + parseInt(items.indexOf(item))}
                  </h1>

                  <p
                    style={{
                      margin: "0 0 10px",
                      paddingRight: "20px",
                      height: "50px",
                    }}
                  >
                    {item.name}
                  </p>
                  <p
                    style={{
                      margin: "0 0 40px",
                      height: "40px",
                      paddingRight: "50px",
                      width: "180px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    {item.description}
                  </p>

                  <a
                    style={{ textDecoration: "none", color: "#2B99FF" }}
                    href={item.html_url}
                  >
                    View
                  </a>
                </div>
              </Slide>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Moreworks;
